import routes from '@configs/api'

export const GET_SEARCH_SUMMARY_URL = () => {
  return routes.SEARCH + '/summary'
}
